import { Component, ViewChild, ChangeDetectorRef, OnInit, OnDestroy, AfterViewInit, ElementRef, Input, HostBinding, NgZone } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { Observable, forkJoin } from 'rxjs';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { ReportsService } from '../../services/reports.service';
import { PaymentsService } from '../../services/payments.service';
import { OrdersService } from '../../services/orders.service';
import { PrintService } from '../../services/print.service';
import * as FileSaver from 'file-saver';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-openorders-and-invoices',
	templateUrl: './openorders-and-invoices.component.html',
	styleUrls: ['./openorders-and-invoices.component.scss']
})
export class OpenordersAndInvoicesComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatPaginator, { static: true }) orderpaginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild('invoiceDetails') invoiceDetailsRef: ElementRef;
	@ViewChild('orderDetails') orderDetailsRef: ElementRef;
	@Input() injectedData: any = false;

	@HostBinding('class.is-narrow') isNarrow = false;
	@HostBinding('class.is-compact') isCompact = false;
	@HostBinding('class.is-tiny') isTiny = false;
	private resizeObserver: ResizeObserver | null = null;

	dataSource = new MatTableDataSource < any > ();
	dataSourceOrders = new MatTableDataSource < any > ();

	displayedColumns: string[] = ['actions', 'orderno', 'trandate', 'typename', 'customer', 'ovamount', 'ovgst', 'ovfreight', 'total', 'tracking', 'printedpackingslip'];

	dataObs: Observable < any > ;
	dataObsOrders: Observable < any > ;
	invoices: any[] = [];
	openorders: any[] = [];
	items_per_page = [10, 25, 50, 100, 500];
	pagesizedefault = 100;
	running = false;
	runningOrders = false;
	today = new Date();
	payments: any = [];
	transactions: any = [];
	mergedResults: any = [];
	searchInput = new FormControl('');
	searchInputOrders = new FormControl('');
	showOrderDetails = false;
	showInvoiceDetails = false;
	showDatePicker = false;
	total_pay = '';
	total_trans = 0;
	total_sub = 0;
	total_tax = 0;
	total_freight = 0;
	total_fee = 0;
	total_discount = 0;

	statusSearch = new UntypedFormControl('');
	sortby = new UntypedFormControl('all');
	datefrom = new FormControl(this.today);
	dateto = new FormControl(this.today);
	datefromOrders = new FormControl(this.today);
	datetoOrders = new FormControl(this.today);
	create_credit = new FormControl(true);
	defaultlocation = new FormControl('');
	salesperson = new FormControl('');
	order_statuses: any = [];
	statusMap: { [id: string]: { name: string; bg: string; fg: string } } = {};
	user: any;
	salesman: any;
	orderdetails: any = false;
	displaydetails: any = false;
	sortDirection = 'asc';
	sortByColumn = '';
	config: any = false;
	invoicelink = '';
	sortOptions = [
		{ view: 'Open Orders', value: 'open' },
		{ view: 'Invoiced', value: 'invoiced' },
		{ view: 'All', value: 'all' }
	];
	allResults: any;

	private readonly defaultStatusPalette: { [key: string]: { bg: string; fg: string } } = {
		invoice:   { bg: '#1b5e20', fg: '#ffffff' },
		invoiced:  { bg: '#00591D', fg: '#ffffff' },
		pending:   { bg: '#ff8f00', fg: '#000000' },
		credit:    { bg: '#b71c1c', fg: '#ffffff' },
		credited:  { bg: '#A30000', fg: '#ffffff' },
		cancelled: { bg: '#616161', fg: '#ffffff' },
		default:   { bg: '#607d8b', fg: '#ffffff' },
	};

	constructor(
		private ordersService: OrdersService,
		private cdr: ChangeDetectorRef,
		private location: Location,
		private reportsService: ReportsService,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService,
		private globalsService: GlobalsService,
		private paymentsService: PaymentsService,
		private fb: FormBuilder,
		private modalService: NgbModal,
		private hostRef: ElementRef<HTMLElement>,
		private zone: NgZone
	) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;

			this.ordersService.getOrderStatuses().subscribe((res: any) => {
				this.order_statuses = Array.isArray(res) ? res : [];
				this.buildStatusMap(this.order_statuses);
				if (!this.config.liveinventory) {
					const filteredStatuses = this.order_statuses
						.filter(status => status.order_status_id !== '51')
						.map(status => status.order_status_id);
					this.statusSearch.setValue(filteredStatuses);
				}
			});
		});
	}

	ngOnInit() {
		if(!this.injectedData){
			this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;
			this.initDateControls();
			this.globalSearchService.userData.subscribe(r => {
				this.user = r;
				this.salesman = this.user.user.issalesman ? this.user.user.salesman : null;
				this.loadAllData();
			});
		}else{
			this.allResults = this.injectedData;
		}


		this.searchInput.valueChanges.subscribe(() => this.search());
		this.datefrom.valueChanges.subscribe(() => this.loadAllData());
		this.dateto.valueChanges.subscribe(() => this.loadAllData());
	}

	ngAfterViewInit(): void {
		const host = this.hostRef?.nativeElement;
		if (!host || typeof ResizeObserver === 'undefined') {
			this.updateBreakpoint(host ? host.getBoundingClientRect().width : window.innerWidth);
			return;
		}

		this.zone.runOutsideAngular(() => {
			this.resizeObserver = new ResizeObserver(entries => {
				const width = entries[0]?.contentRect?.width ?? host.getBoundingClientRect().width;
				this.zone.run(() => this.updateBreakpoint(width));
			});
			this.resizeObserver.observe(host);
		});

		this.updateBreakpoint(host.getBoundingClientRect().width);
	}

	ngOnDestroy(): void {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
	}

	private updateBreakpoint(width: number): void {
		const tiny = width > 0 && width < 420;
		const narrow = width > 0 && width < 768;
		const compact = width > 0 && width < 992;
		if (narrow !== this.isNarrow || compact !== this.isCompact || tiny !== this.isTiny) {
			this.isTiny = tiny;
			this.isNarrow = narrow;
			this.isCompact = compact;
			this.cdr.markForCheck();
		}
	}

	initDateControls() {
		const rawDaysBack = this.config?.dashboardSalesmanDaysBack;
		const parsedDaysBack = Number(rawDaysBack);
		const daysBack = Number.isFinite(parsedDaysBack) && parsedDaysBack >= 0 ? Math.floor(parsedDaysBack) : 3;

		const fromDate = new Date();
		fromDate.setDate(fromDate.getDate() - daysBack);

		this.datefrom.setValue(fromDate);
		this.dateto.setValue(this.today);
		this.datefromOrders.setValue(fromDate);
		this.datetoOrders.setValue(this.today);
	}

	/** Rows returned from the orders API (salesorders pipeline), including dispatch-queue subset. */
	private isSalesOrderPipelineRow(o: any): boolean {
		const id = o?.orderstatusid;
		return !(id === undefined || id === null || id === '');
	}

	/** Open / in-progress sales orders — excludes dispatch-invoiced bucket (`invoiced === true`). */
	private isOpenSalesOrderRow(o: any): boolean {
		return this.isSalesOrderPipelineRow(o) && o.invoiced !== true;
	}

	/** Posted AR invoices & credit notes, plus sales-order rows flagged as invoiced-on-dispatch. */
	private isInvoicedOrArRow(o: any): boolean {
		if (!o) {
			return false;
		}
		if (o.invoiced === true) {
			return true;
		}
		const typ = String(o.type ?? '');
		if (typ === '10' || typ === '11') {
			return true;
		}
		if (this.isSalesOrderPipelineRow(o)) {
			return false;
		}
		const tn = (o.typename || '').toString().toLowerCase();
		if (tn.includes('invoice')) {
			return true;
		}
		if (typ === '11' || (tn.includes('credit') && tn.includes('note'))) {
			return true;
		}
		return false;
	}

	sortData() {
		const opt = this.sortby.getRawValue();
		const out = Array.isArray(this.allResults) ? this.allResults : [];
		switch (opt) {
		case 'open':
			this.mergedResults = out.filter(o => this.isOpenSalesOrderRow(o));
			break;
		case 'invoiced':
			this.mergedResults = out.filter(o => this.isInvoicedOrArRow(o));
			break;
		default:
			this.mergedResults = out;
			break;
		}

		this.updateTotals(this.mergedResults);
		this.setPagination(this.mergedResults);
	}

	loadAllData() {
		const requestParams = {
			from: this.datefrom.value,
			to: this.dateto.value,
			locations: this.defaultlocation.value,
			salesperson: this.salesman
		};

		this.running = this.runningOrders = true;

		forkJoin({
			invoices: this.paymentsService.getDailyTransactions(requestParams),
			orders: this.ordersService.getItemOrderSearch(requestParams)
		}).subscribe(({ invoices, orders }) => {
			this.running = this.runningOrders = false;
			this.processInvoicesData(invoices);
			this.processOrdersData(orders);

			this.allResults = [...this.transactions, ...this.openorders];
			this.sortData();
		});
	}

	processInvoicesData(invoices: any) {
		this.payments = invoices;

		// Ensure each transaction has the printedpackingslip flag
		this.transactions = invoices.transactions.map((transaction: any) => {
			if (!transaction.hasOwnProperty('printedpackingslip')) {
				transaction.printedpackingslip = '1'; // Add printedpackingslip with value '1' if it doesn't exist
			}
			return transaction;
		});

		this.updateTotals(this.transactions);
	}

	processOrdersData(orders: any) {

		const selectedStatuses = this.statusSearch.value; // This is now an array of selected statuses

		if (selectedStatuses.length > 0 && !selectedStatuses.includes('')) {
			const searchresults = orders.filter(order => {
				return selectedStatuses.includes(order.orderstatusid)
			});

			orders = searchresults;
		}

		this.openorders = orders;
	}

	updateTotals(transactions: any[]) {
		this.total_trans = transactions.reduce((acc, item) => acc + parseFloat(item.total), 0);
		this.total_sub = transactions.reduce((acc, item) => acc + parseFloat(item.ovamount), 0);
		this.total_tax = transactions.reduce((acc, item) => acc + parseFloat(item.ovgst), 0);
		this.total_freight = transactions.reduce((acc, item) => acc + parseFloat(item.ovfreight), 0);
		this.total_fee = transactions.reduce((acc, item) => acc + parseFloat(item.ovfee), 0);
		this.total_discount = transactions.reduce((acc, item) => acc + parseFloat(item.ovdiscount), 0);
		this.total_pay = transactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
	}

	search() {
		const value = this.searchInput.value?.trim();
		const filteredData = value ? this.globalSearchService.filterItem(this.mergedResults, value, 'orderno,deliverto,transno,name,total,debtorno,branchcode,tracking_display') : this.mergedResults;
		this.setPagination(filteredData);
		this.updateTotals(filteredData);
	}

	setPagination(data: any[]) {

		this.dataSource = new MatTableDataSource < any > (data);
		this.cdr.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.dataObs = this.dataSource.connect();

	}

	viewOrder(orderno: any) {
		this.showOrderDetails = true;
		this.ordersService.getOrder(orderno).subscribe(order => {
			this.orderdetails = order;
			this.showModal(this.orderDetailsRef, 'orderDetails', order);
		});
	}

	openDocument(transaction: any, display: string) {
		this.showInvoiceDetails = true;
		const fetchDetails = transaction.type === '11' ? this.globalsService.getCreditNote(transaction.id, display) : this.globalsService.getInvoice(transaction.id, display);
		fetchDetails.subscribe(result => {
			this.showModal(this.invoiceDetailsRef, 'invoiceDetails', result);
		});
	}

	showModal(ref: ElementRef, modalType: string, data: any) {
		if (modalType === 'orderDetails') {
			this.orderdetails = data;
		} else if (modalType === 'invoiceDetails') {
			this.displaydetails = data;
		}
		this.modalService.open(ref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {
			this.resetModalState(modalType);
		}, () => {
			this.resetModalState(modalType);
		});
	}

	resetModalState(modalType: string) {
		if (modalType === 'orderDetails') {
			this.showOrderDetails = false;
			this.orderdetails = null;
		} else if (modalType === 'invoiceDetails') {
			this.showInvoiceDetails = false;
			this.displaydetails = null;
		}
	}

	toggleDatePicker(): void {
		this.showDatePicker = !this.showDatePicker;
	}

	isInvalidDateRange(): boolean {
		// Check if either datefrom or dateto is empty (null or undefined)
		return !this.datefrom.value || !this.dateto.value;
	}

	calculateDaysBetween(startDate: Date | null, endDate: Date | null): string {
		if (!startDate || !endDate) {
			return '';
		}
		const millisecondsPerDay = 1000 * 60 * 60 * 24;
		const days = Math.round((endDate.getTime() - startDate.getTime()) / millisecondsPerDay);

		if (days === 0) {
			return 'Today';
		}
		return days === 1 ? '1 day' : `${days} days`;
	}

	private buildStatusMap(statuses: any[]): void {
		const map: { [id: string]: { name: string; bg: string; fg: string } } = {};
		for (const s of statuses || []) {
			const id = String(s.order_status_id ?? '');
			if (!id) {
				continue;
			}
			const bgRaw = s.badge_bg ? String(s.badge_bg).trim() : '';
			const fgRaw = s.badge_fg ? String(s.badge_fg).trim() : '';
			const fallback = this.fallbackByStatusId(id, s.name);
			map[id] = {
				name: s.name ?? fallback.name,
				bg: bgRaw || fallback.bg,
				fg: fgRaw || fallback.fg,
			};
		}
		this.statusMap = map;
	}

	private fallbackByStatusId(id: string, name?: string): { name: string; bg: string; fg: string } {
		const n = (name || '').toLowerCase();
		if (n) {
			for (const key of Object.keys(this.defaultStatusPalette)) {
				if (n.includes(key)) {
					return { name: name || key, ...this.defaultStatusPalette[key] };
				}
			}
		}
		const num = parseInt(id, 10);
		if (!isNaN(num)) {
			if (num === 50 || num === 53) {
				return { name: name || 'Invoiced', ...this.defaultStatusPalette.invoiced };
			}
			if (num >= 51 && num <= 52) {
				return { name: name || 'Cancelled', ...this.defaultStatusPalette.cancelled };
			}
			if (num >= 80) {
				return { name: name || 'Credit', ...this.defaultStatusPalette.credit };
			}
			if (num >= 30 && num < 50) {
				return { name: name || 'In Progress', bg: '#1976d2', fg: '#ffffff' };
			}
			if (num > 0 && num < 30) {
				return { name: name || 'Pending', ...this.defaultStatusPalette.pending };
			}
		}
		return { name: name || 'Unknown', ...this.defaultStatusPalette.default };
	}

	getStatusStyle(item: any): { bg: string; fg: string; label: string } {
		const orderStatusId = item?.orderstatusid != null ? String(item.orderstatusid) : '';
		const typename = (item?.statusname || item?.typename || '').toString();
		const key = typename.toLowerCase().replace(/\s+/g, '');
		const type = item?.type != null ? String(item.type) : '';

		if (key === 'invoiced') {
			return { ...this.defaultStatusPalette.invoiced, label: typename };
		}
		if (key === 'credited') {
			return { ...this.defaultStatusPalette.credited, label: typename };
		}

		if (orderStatusId && this.statusMap[orderStatusId]) {
			const raw = this.statusMap[orderStatusId];
			return { bg: raw.bg, fg: raw.fg, label: typename || raw.name };
		}

		if (key.includes('credit') || type === '11') {
			return { ...this.defaultStatusPalette.credit, label: typename || 'Credit Note' };
		}
		if (key.includes('invoice') || type === '10') {
			return { ...this.defaultStatusPalette.invoice, label: typename || 'Invoice' };
		}
		if (key.includes('pending')) {
			return { ...this.defaultStatusPalette.pending, label: typename };
		}
		if (key.includes('cancel')) {
			return { ...this.defaultStatusPalette.cancelled, label: typename };
		}

		const fb = this.fallbackByStatusId(orderStatusId, typename);
		return { bg: fb.bg, fg: fb.fg, label: fb.name };
	}
}